import { queryPathBuilder } from '../../util/queryPathBuilder';
import {
  CREATE_CONSIGNMENT_ORDER,
  DATA_DELETED,
  DELETE_CONSIGNMENT_ORDER,
  GET_CONSIGNMENT_ORDERS,
  GET_CONSIGNMENT_ORDER_BY_ID,
  GET_CONSIGNMENT_ORDER_MOVEMENTS,
  UPDATE_CONSIGNMENT_ORDER,
} from '../types';
import { get, post, put, remove } from './Action';

const basePath = '/consignment-order';

// Create Consignment Order
export const createConsignmentOrder = (order) => async (dispatch) => {
  return await dispatch(post(`${basePath}/create`, order, createConsignmentDS));
};

// Get Consignment Orders
export const getConsignmentOrders = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(
    get(`${basePath}${queryParams}`, getConsignmentOrdersDS, true)
  );
};

// Get Consignment Order By Id
export const getConsignmentOrderById = (id) => async (dispatch) => {
  return await dispatch(get(`${basePath}/${id}`, getConsignmentOrderByIdDS));
};

// Edit Consignment Order
export const updateConsignmentOrder = (id, order) => async (dispatch) => {
  return await dispatch(
    put(`${basePath}/${id}/update`, order, updateConsignmentOrderDS)
  );
};

// Delete Consignment Order
export const deleteConsignmentOrder = (id) => async (dispatch) => {
  const response = await dispatch(
    remove(`${basePath}/${id}/delete`, deleteConsignmentOrderDS)
  );
  dispatch(consignmentDeleteDS(id));
  return response;
};

export const getConsignmentOrderMovements = (id) => async (dispatch) => {
  return await dispatch(
    get(`${basePath}/movements/${id}`, consignmentMovementsDS, true)
  );
};

export const approveConsigmentOrder = (id) => async (dispatch) => {
  return await dispatch(
    put(`${basePath}/${id}/approve`, updateConsignmentOrderDS)
  );
};

export const getConsignmentOrderMovementDetails =
  (id, params) => async (dispatch) => {
    const queryParams = queryPathBuilder(params);
    return await dispatch(
      get(
        `${basePath}/movements-details/${id}${queryParams}`,
        consignmentMovementsDS,
        true
      )
    );
  };

const createConsignmentDS = (order) => ({
  type: CREATE_CONSIGNMENT_ORDER,
  payload: order,
});

const getConsignmentOrdersDS = (orders) => ({
  type: GET_CONSIGNMENT_ORDERS,
  payload: orders.items,
});

const getConsignmentOrderByIdDS = (order) => ({
  type: GET_CONSIGNMENT_ORDER_BY_ID,
  payload: order,
});

const updateConsignmentOrderDS = (order) => ({
  type: UPDATE_CONSIGNMENT_ORDER,
  payload: order,
});

export const consignmentDeleteDS = (id) => ({
  type: DATA_DELETED,
  payload: id,
});

const deleteConsignmentOrderDS = (order) => ({
  type: DELETE_CONSIGNMENT_ORDER,
  payload: order,
});

export const consignmentMovementsDS = (movements) => ({
  type: GET_CONSIGNMENT_ORDER_MOVEMENTS,
  payload: movements,
});
